import ky from 'ky';

export const dsFetch = ky.extend({
  credentials: 'include',
  redirect: 'error',
  headers: {
    'x-requested-with': 'XMLHttpRequest',
    'content-type': 'application/json;charset=UTF-8',
  },
  timeout: 25000,
  hooks: {
    beforeRequest: [],
    afterResponse: [
      async (request, options, response) => {
        if (response.status === 401) {
          const result = await response.json();
          if (result.error === 'invalid_client') {
            const passportUrl = new URL(result.x3ds_auth_url as string).origin;
            const serviceUrl = new URL(window.location.href);
            serviceUrl.searchParams.set('passport', passportUrl);
            window.location.href = `${passportUrl}/login?service=${encodeURIComponent(
              serviceUrl.toString(),
            )}`;
          }
        }
      },
    ],
  },
});

const extractPropertyFromXML = (xml: string, property: string) => {
  const regex = new RegExp(`<${property}>([^(</)]*)</${property}>`);
  const result = regex.exec(xml);
  if (result?.length) {
    return result[1];
  }

  return '';
};

const extractUserFromXML = (xml: string) => ({
  user: extractPropertyFromXML(xml, 'cas:user'),
  proxyGrantingTicket: extractPropertyFromXML(xml, 'cas:proxyGrantingTicket'),
  attributes: {
    lastName: extractPropertyFromXML(xml, 'cas:lastName'),
    firstName: extractPropertyFromXML(xml, 'cas:firstName'),
    email: extractPropertyFromXML(xml, 'cas:email'),
    username: extractPropertyFromXML(xml, 'cas:username'),
    country: extractPropertyFromXML(xml, 'cas:country'),
    language: extractPropertyFromXML(xml, 'cas:language'),
    passwordCreationTime: extractPropertyFromXML(xml, 'cas:passwordCreationTime'),
  },
});

const wasUserJustCreated = (passwordCreationTime: string) => {
  if (!passwordCreationTime) {
    return false;
  }

  const secondsSincePasswordCreation =
    (new Date(Date.now()).getTime() - new Date(parseInt(passwordCreationTime, 10)).getTime()) /
    1000;
  return secondsSincePasswordCreation < 15;
};

export const loginWithTicket = async (ticket: string, passport: string) => {
  if (!ticket || !passport) {
    return;
  }

  try {
    const passportUrl = new URL(
      `${new URL(passport).origin}/proxyValidate?xrequestedwith=xmlhttprequest`,
    );

    const serviceUrl = new URL(window.location.href);
    serviceUrl.searchParams.delete('ticket');
    passportUrl.searchParams.set('ticket', ticket);
    passportUrl.searchParams.set('service', serviceUrl.toString());

    const passportValidation = await dsFetch(passportUrl);
    const xmlPassport = await passportValidation?.text();
    const user = extractUserFromXML(xmlPassport);
    const justCreated = wasUserJustCreated(user.attributes.passwordCreationTime);
    return { ...user, justCreated };
  } catch (e) {
    return null;
  }
};
